module.exports = __webpack_public_path__ + "img/sintmaarten.b568b0d0.svg";